import { render, staticRenderFns } from "./SchemeSafety.vue?vue&type=template&id=eb635b4e&scoped=true"
import script from "./SchemeSafety.vue?vue&type=script&lang=js"
export * from "./SchemeSafety.vue?vue&type=script&lang=js"
import style0 from "./SchemeSafety.vue?vue&type=style&index=0&id=eb635b4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb635b4e",
  null
  
)

export default component.exports